import { StyleSheet } from '@react-pdf/renderer';

import theme from '@/theme/index';

export const styles = StyleSheet.create({
  page: {
    flexDirection: 'column',
    backgroundColor: theme.colors.light,
    padding: 10,
  },
  coverpage: {
    flexDirection: 'column',
    backgroundColor: theme.colors.light,
    padding: 0,
    margin: 0,
  },
  coverWrapper: {
    position: 'relative',
    width: '100%',
    height: '100%',
  },
  section: {
    margin: 10,
    padding: 10,
  },
  header: {
    height: 30,
    backgroundColor: theme.colors.grayLighter,
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    marginBottom: 10,
  },
  title: {
    fontSize: 18,
    color: theme.colors.bluePrimary,
    fontWeight: 'bold',
    textAlign: 'center',
  },
  titleWrapper: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  reportTitle: {
    fontSize: 32,
    color: theme.colors.bluePrimary,
    fontWeight: 'bold',
    textAlign: 'center',
    width: '60%',
    padding: 10,
  },
  reportName: {
    fontSize: 24,
    textAlign: 'center',
    color: theme.colors.primary,
    marginBottom: 10,
  },
  subTitle: {
    fontSize: 14,
    textAlign: 'center',
    marginBottom: 10,
  },
  text: {
    fontSize: 12,
    marginBottom: 5,
  },
  bold: {
    fontWeight: 'bold',
  },
  metricRow: {
    flexDirection: 'row',
    borderBottomWidth: 1,
    borderBottomColor: theme.colors.grayLight,
    paddingTop: 5,
    paddingBottom: 5,
  },
  metricLabelCell: {
    width: '60%',
    paddingLeft: 5,
  },
  metricValueCell: {
    width: '40%',
    textAlign: 'right',
    paddingRight: 5,
  },
  chartImage: {
    width: '100%',
    height: 320,
    objectFit: 'contain',
    alignSelf: 'center',
  },
  footer: {
    position: 'absolute',
    bottom: 20,
    left: 0,
    right: 0,
    height: 15,
    backgroundColor: theme.colors.bluePrimary,
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingHorizontal: 10,
  },
  footerText: {
    color: theme.colors.light,
    fontSize: 8,
  },
  footerCenter: {
    color: theme.colors.light,
    fontSize: 10,
    fontWeight: 'bold',
  },
  coverImage: {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
  },
  bestSimulationTitle: {
    marginTop: 15,
  },
  metricsContainer: {
    marginTop: 20,
    padding: 10,
    backgroundColor: theme.colors.grayPale,
    borderRadius: 3,
  },
  keyMetricsTitle: {
    color: theme.colors.bluePrimary,
  },
  lastMetricRow: {
    borderBottomWidth: 0,
  },
  chartCaption: {
    fontSize: 10,
    fontStyle: 'italic',
    color: theme.colors.grayDark,
    textAlign: 'center',
    marginTop: 5,
    marginBottom: 0,
  },
  chartContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    margin: 0,
    padding: 0,
  },
  reportSubtitle: {
    fontSize: 24,
    color: '#2b5aa7',
    fontWeight: 'bold',
    textAlign: 'center',
    marginBottom: 10,
    textTransform: 'uppercase',
  },
});
